import { defineMessages } from 'react-intl';

export default defineMessages({
  bundleIncludedSectionTitle: {
    id: 'BundleItemProductCard.bundleIncludedSectionTitle',
    description: 'Title for What\'s Included section in product card',
    defaultMessage: 'What\'s Included',
  },
});
